import classnames from "classnames/bind";
import styles from "../introduce.module.scss";

const cx = classnames.bind(styles);

const Competency = () => {

	return (
		<div className={cx('contents')}>
			<div className={cx('titleWrap')}>
				<span className={cx('title')}>역량으로<br />알 수 있습니다</span>
			</div>
			<div className={cx('competencyCardWrap')}>
				<div className={cx('competencyCard')}>
					<div className={cx('competencyTextWrap')}>
						<div className={cx('competencyTitleWrap')}>
							<span className={cx('competencyDeco')}>역량은 언제, 어떻게 만들어지나요?</span>
							<span className={cx('competencyTitle')}>모든 경험과 체험의<br />과정, 결과로<br />역량은 만들어집니다.</span>
						</div>
					</div>
					<div className={cx('competencyDescArea')}>
						<span className={cx('competencyDesc')}>사람의 역량은 출생한 후에 성장발달 과정에서 세상과의 상호작용을 통한 다양한 체험과 경험으로 만들어집니다. 태어났을 때 미성숙의 뇌는 성장 과정을 거치면서 20세 전후가 되면 거의 완성되는 것으로 알려져 있습니다.</span>
						<span className={cx('competencyDesc')}>
							잡다의 역검에서 핵심역량이라고 정의하는 긍정성, 적극성, 전략성, 성실성, 관계성, 정체성, 객관성은 부모, 형제, 또래, 친구, 선생님을 포함하여
							<em className={cx('bold')}> 가정과 학교 그리고 사회생활에서 만나는 사람들과 환경과의 상호작용으로 이루어지는 모든 체험과 경험의 과정과 결과를 통해 만들어집니다.</em>
						</span>
						<span className={cx('competencyDesc')}>
							역량은 뇌가 환경에 대응하는 과정에서 형성되는 적응 능력이며, 우리의 삶의 수준을 결정짓는 중요한 요소입니다. 7가지 핵심역량을 이해하고
							<em className={cx('bold')}> 성인이 된 이후에는 긍정기술, 전략기술, 성찰기술과 같은 역량기술을 학습하고 습관화한다면 우리는 역량을 강화하고 함양할 수 있습니다.</em>
						</span>
					</div>
					<div className={cx('competencyImgWrap', 'type1')} />
				</div>
				<div className={cx('competencyCard')}>
					<div className={cx('competencyTextWrap')}>
						<div className={cx('competencyTitleWrap')}>
							<span className={cx('competencyDeco')}>역검 리포트는 무엇인가요?</span>
							<span className={cx('competencyTitle')}>세계 최초로 제공되는<br />청년을 위한<br />역량 기반 리포트입니다.<br /></span>
							<span className={cx('competencyTitleDesc')}>잡다의 역검 리포트는 세계 최초로 신경과학 알고리즘과 인공지능 기술을 융합한 역량검사솔루션인 ‘역검’에서 구직자에게 제공하는 결과리포트입니다.</span>
						</div>
					</div>
					<div className={cx('competencyDescArea')}>
						<div className={cx('competencyDescWrap')}>
							<span className={cx('competencyDesc', 'em')}>역검이란?</span>
							<span className={cx('competencyDesc')}>
								<em className={cx('bold')}>역검은 3가지 TASK(성향파악, 전략게임, 영상면접)을 통해 구직자의 성과역량, 가치역량 그리고 관찰특성을 확인합니다.</em> 성과역량은 성과를 만드는 전전두엽의 7가지 핵심역량을, 가치역량은 정서적 안정감이나 사회적 책임감을 바탕으로 한 조직내 성장가능성을, 그리고 관찰특성은 상황질문에 대한 답변을 통해  소통역량을 측정합니다.
							</span>
						</div>
						<div className={cx('competencyDescWrap')}>
							<span className={cx('competencyDesc', 'em')}>역검 리포트에는 어떤 내용이 담겨 있나요?</span>
							<span className={cx('competencyDesc')}>먼저, <em className={cx('bold')}>응시결과 분석리포트</em>는 역검에 대한 올바른 이해와 적응을 돕고 응시결과 요약, 성향파악/영상면접/전략게임 가이드와 맞춤형 응시 꿀팁 등을 제공합니다.</span>
							<span className={cx('competencyDesc')}>또한, 자신의 역량을 객관적으로 이해하도록 돕기 위한 역량 결과 분석을 제공합니다. 구직자의 역량결과(성과역량, 가치역량, 소통역량)를 분석하여 역검에서 정의하는 12가지 역량유형과 유형에 맞는 다양한 정보가 포함되어 있습니다.</span>
							<span className={cx('competencyDesc')}>또한 핵심역량에 대한 역량프로파일을 통해 구직자의 뛰어난 TOP3역량과 강점 및 약점의 정보를 안내합니다.</span>
							<span className={cx('competencyDesc')}>이를 통해 구직자는 본인의 역량을 보다 합리적이고 선명하게 확인함으로써
								<em className={cx('bold')}> 역검을 통해 자신의 진짜 역량을 객관적으로 바라볼 수 있는 기회를 제공합니다.</em>
							</span>
							<span className={cx('competencyDesc')}>추가적으로, 구직자에게 맞춤형 기업 문화 소개, 직군 및 직무 추천을 통해 내 역량을 제대로 펼칠 수 있는 방향도 제시해 줍니다.</span>
						</div>
					</div>
					<div className={cx('competencyImgWrap', 'type2')} />
				</div>
			</div>
		</div>
	)
};

export default Competency;

